<template>
  <v-card class="folder-thumb pa-3 ma-2 rounded-lg" variant="flat" color="#F6F5F5" :min-width="grid ? 170 : undefined"
    :style="grid ? 'max-width: 400px' : 'width: 100%'" role="button" tabindex="0" @click="$emit('click')"
    @keydown.enter.prevent="$emit('click')" @keydown.space.prevent="$emit('click')">
    <!-- Compact grid / card gallery -->
    <template v-if="grid">
      <v-icon size="50" :color="color" icon="mdi-folder" class="mb-1" />
      <p v-if="description" class="mb-0 text-medium-emphasis" style="font-size: 11px;">
        {{ description }}
      </p>
      <h6 class="mb-0 mt-1" style="opacity: 0.9;">{{ name }}</h6>
      <p class="mb-0 mt-1 text-medium-emphasis" style="font-size: 12.5px;">{{ fileCount }} files</p>
    </template>

    <!-- List row: compact legacy-style layout -->
    <div v-else class="folder-thumb__row">
      <v-icon class="folder-thumb__icon" size="35" :color="color" icon="mdi-folder" />
      <div class="folder-thumb__text">
        <div v-if="description" class="folder-thumb__desc text-medium-emphasis">{{ description }}</div>
        <div class="folder-thumb__name">{{ name }}</div>
      </div>
      <div class="folder-thumb__count text-medium-emphasis">{{ fileCount }} files</div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "FolderThumb",
  props: {
    name: String,
    description: String,
    fileCount: Number,
    color: String,
    grid: Boolean,
  },
  emits: ["click"],
};
</script>

<style scoped>
.folder-thumb {
  cursor: pointer;
}

.folder-thumb:focus-visible {
  outline: 2px solid rgb(var(--v-theme-primary));
  outline-offset: 2px;
}

.folder-thumb__row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.folder-thumb__icon {
  margin-top: 2px;
  flex: 0 0 auto;
}

.folder-thumb__text {
  min-width: 0;
  flex: 1 1 auto;
}

.folder-thumb__desc {
  font-size: 11px;
  line-height: 1.25;
  margin-bottom: 2px;
}

.folder-thumb__name {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  color: rgba(0, 0, 0, 0.87);
  overflow-wrap: anywhere;
}

.folder-thumb__count {
  flex: 0 0 auto;
  font-size: 12.5px;
  line-height: 1.25;
  white-space: nowrap;
  margin-top: 2px;
}
</style>
